import React from "react";
import ProductCard from "./ProductCard";

function ProductGrid({
  products = [],
  className = "",
  label = "Products",
  priorityCount = 0,
}) {
  const classes = ["product-grid", className].filter(Boolean).join(" ");

  return (
    <div className={classes} role="list" aria-label={label}>
      {products.map((product, index) => (
        <ProductCard
          key={product.id}
          product={product}
          priority={index < priorityCount}
        />
      ))}
    </div>
  );
}

export default ProductGrid;
